import { CalendarRange, FolderKanban, ListChecks, ShieldCheck } from 'lucide-react';
import { Link } from 'wouter';
import { SidebarMenuButton, SidebarMenuItem } from '@/components/ui/sidebar';
import { usePmMe } from '../data/queries';
import { PM_SCREENS } from './pm-screens';

/**
 * "R&D" sidebar group: Follow-up for everyone who can see it, My work / Projects / PM Admin by grant (v1.3 order: My work
 * first). `isActive` is the shared sidebar API.
 */
export function PmSidebarSection({ location }: { location: string }) {
  const { data } = usePmMe();
  const canAccess = !!data?.canAccess;
  if (!data || !(canAccess || (data.canSeeFollowUp ?? false))) return null;
  const onProjects = location === '/pm' || location.startsWith('/pm/projects');
  return (
    <>
      <SidebarMenuItem className="pt-4">
        <div className="mb-2 px-3 text-xs font-semibold text-byacre-royal-blue">R&amp;D</div>
      </SidebarMenuItem>
      {canAccess ? (
      <SidebarMenuItem>
        <SidebarMenuButton asChild isActive={location.startsWith('/pm/my-work')}>
          <Link href="/pm/my-work" title={PM_SCREENS.myWork.subtitle}>
            <ListChecks className="h-4 w-4" />
            <span>{PM_SCREENS.myWork.title}</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
      ) : null}
      {canAccess ? (
      <SidebarMenuItem>
        <SidebarMenuButton asChild isActive={onProjects}>
          <Link href="/pm" title={PM_SCREENS.projects.subtitle}>
            <FolderKanban className="h-4 w-4" />
            <span>{PM_SCREENS.projects.title}</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
      ) : null}
      <SidebarMenuItem>
        <SidebarMenuButton asChild isActive={location.startsWith('/pm/timeline')}>
          <Link href="/pm/timeline" title={PM_SCREENS.followUp.subtitle}>
            <CalendarRange className="h-4 w-4" />
            <span>{PM_SCREENS.followUp.title}</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
      {canAccess && data.isAdmin ? (
        <SidebarMenuItem>
          <SidebarMenuButton asChild isActive={location.startsWith('/pm/admin')}>
            <Link href="/pm/admin">
              <ShieldCheck className="h-4 w-4" />
              <span>PM Admin</span>
            </Link>
          </SidebarMenuButton>
        </SidebarMenuItem>
      ) : null}
    </>
  );
}
